import {
  LOAD_BUILDER_CREATED_PAGES,
  LOAD_BUILDER_CREATED_PAGES_FAIL,
  LOAD_BUILDER_CREATED_PAGES_SUCCESS,
  LOAD_GENERATED_WEBSITES_COUNT, LOAD_GENERATED_WEBSITES_COUNT_SUCCESS,
  LoadBuilderCreatedPagesFails,
  LoadBuilderCreatedPagesSuccess, LoadGeneratedWebsiteCount, LoadGeneratedWebsiteCountSuccess
} from '../actions';
import {AiBuilderAction} from "../actions";
import {
  IAIBuilderPage
} from "../../websites/website/ai-builder/ai-builder-pages/ai-builder-pages-table/ai-builder-pages-table.component";

export interface IAiBuilderEntityState {
  entities: { [websiteId: number]: IAIBuilderPage[] };
  generatedWebsiteCount: number;
  loading: boolean;
  loaded: boolean;
}

export interface IAiBuilderState {
  entities: { [websiteId: number]: IAiBuilderEntityState };
  generatedWebsiteCount: number;
  canRegenerate: boolean;
}

export const initialState: IAiBuilderState = {
  entities: {},
  generatedWebsiteCount: 0,
  canRegenerate: true
};

export function reducer(state: IAiBuilderState = initialState, action: AiBuilderAction): IAiBuilderState {
  let payload: any;

  switch (action.type) {

    case  LOAD_BUILDER_CREATED_PAGES:
      payload = (<LoadBuilderCreatedPagesSuccess>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload]: {
            ...state[payload],
            loading: true,
            loaded: false
          }
        }
      };

    case LOAD_BUILDER_CREATED_PAGES_SUCCESS:
      payload = (<LoadBuilderCreatedPagesSuccess>action).payload;
      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            entities: payload.entities,
            loading: false,
            loaded: true
          }
        }
      };

    case  LOAD_BUILDER_CREATED_PAGES_FAIL:
      payload = (<LoadBuilderCreatedPagesFails>action).payload;

      return {
        ...state,
        entities: {
          ...state.entities,
          [payload.websiteId]: {
            ...state.entities[payload.websiteId],
            loading: false,
            loaded: true
          }
        }
      };

    case  LOAD_GENERATED_WEBSITES_COUNT:
      payload = (<LoadGeneratedWebsiteCount>action).payload;

      return {
        ...state,
      };

    case  LOAD_GENERATED_WEBSITES_COUNT_SUCCESS:
      payload = (<LoadGeneratedWebsiteCountSuccess>action).payload;
      return {
        ...state,
        generatedWebsiteCount: payload.count,
        canRegenerate: payload.can_regenerate
      };
  }

  return state;
}
